var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"halo-tree"},_vm._l((_vm.data),function(item,index){return _c('treeLi',_vm._b({key:item.id ? item.id : index,attrs:{"item":item,"index":index},nativeOn:{"drop":function($event){$event.stopPropagation();_vm.drop(item, $event)},"dragover":function($event){$event.stopPropagation();return _vm.dragover($event)}}},'treeLi',_vm.childBind,false))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61df22b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/treeUl.vue
// module id = 18
// module chunks = 0